import React, { ReactNode, useState } from 'react';

import styles from '@/components/schedule-results/read-more-review.module.scss';

type ReadMoreProps = {
  children: ReactNode;
  t: (string: string) => string;
};

function safeStringSplit(str: string, length: number) {
  // Find the index of the first space after the specified length.
  const spaceIndex = str.indexOf(' ', length);

  // If there is no space after the specified length, return the whole thing
  if (spaceIndex === -1) {
    return str;
  }

  // Split the string at the space index.
  return str.substring(0, spaceIndex);
}

const ReadMoreReview = (props: ReadMoreProps) => {
  const { children, t } = props;
  const content = children ? children.toString().replace(/\s+/g, ' ').trim() : '';
  const [text, setText] = useState(content.length > 250 ? safeStringSplit(content, 250) : content);
  const [expanded, setExpanded] = useState(content.length === text.length ? true : false);
  const buildReviewText = (text: string) => {
    const strings = text.split(/%*CR%+LF%+/);
    return strings.map((string: string, index: number) => {
      if (index + 1 !== strings.length) {
        return (
          <span key={index}>
            {string}
            <br />
          </span>
        );
      }
      return <span key={index}>{string}</span>;
    });
  };
  return (
    <>
      {buildReviewText(text)}
      {content.length > 250 && !expanded && (
        <>
          {'...'}
          <button
            className={styles['read-more']}
            onClick={() => {
              setExpanded(true);
              setText(content);
            }}
          >
            {t('Show More')}
          </button>
        </>
      )}
    </>
  );
};

export default ReadMoreReview;
